import React from "react";
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import './styleCss/Profile.css'
import Loading from "../components/loading/Loading";
import { useState } from "react";
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useRef } from "react";
import {getInstance} from '../api/baseapi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { Button, Col, Row } from "react-bootstrap";
import { fetchProfileDataList } from "../api/User_api";
import ProfileIcon from "../components/profileIcon/ProfileIcon";

function Profile() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    const [isLoading, setLoading] = useState(false);

    const navigate = useNavigate();
    function navigateToBack() {
      navigate(-1);
    }

    const [dataProfileView, setDataProfileView] = useState({
        firstname: null,
        lastname: null,
        email: null,
        mobile: null,
        role: null
    });

    async function getDataProfile() {
        try {
          setLoading(true);
            let response = await fetchProfileDataList();
            setDataProfileView({
              ...dataProfileView,
              firstname: response.firstname,
              lastname: response.lastname,
              email: response.email,
              mobile: response.mobile_no,
              role: response.role.role_name,
            });
          // });
        } catch (error) {
    
        }
      }
    
      useEffect(() => {
        getDataProfile();
      }, []);

  return (
    <>
        {/* {isLoading ? <Loading /> : ""} */}
        <Header parentmenu={"MY PROFILE"} />
        <Menu
            parentmenu={"infoProfile"}
            activemenu={"infoProfile"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex">
                                <Button className="btn-backPage" onClick={() => navigateToBack()}>
                                    <span><FontAwesomeIcon icon={faArrowLeft} className="mr-2"/></span>
                                </Button>
                                My Profile
                            </font>
                        </Col>
                    </Row>
                    <div className="d-flex align-items-center justify-content-center">
                        <Row>
                            <Col xs={2}>
                                <div className="w-100">
                                    <ProfileIcon className={`profile-sty02`}  firstCharacter={dataProfileView?.firstname?.charAt(0)} />
                                </div>
                            </Col>
                            <Col xs={10} className="d-flex align-items-center">
                                <div className="d-flex flex-column">
                                    <font className="fontBold font-size07 colorBlack01">{dataProfileView?.firstname} &nbsp; {dataProfileView?.lastname}</font>
                                    <font className="fontReg font-size02 colorBlack01"><span><FontAwesomeIcon icon={faEnvelope} className="mr-2"/></span>{dataProfileView?.email}</font>
                                </div>
                            </Col>
                            <div className="box-profile mt-4">
                                <Col xs={12} className="border-bottom01">
                                    <div className="pb-4">
                                        <font className="fontBold font-size08 colorBlack01 ">MY PROFILE</font>
                                    </div>
                                </Col>
                                <Col xs={12} className="border-bottom01">
                                    <Row className="my-3">
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorBlack01">Firstname</font>
                                            </div>
                                        </Col>
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorGray01">{dataProfileView?.firstname}</font>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} className="border-bottom01">
                                    <Row className="my-3">
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorBlack01">Lastname</font>
                                            </div>
                                        </Col>
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorGray01">{dataProfileView?.lastname}</font>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} className="border-bottom01">
                                    <Row className="my-3">
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorBlack01">Email</font>
                                            </div>
                                        </Col>
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorGray01">{dataProfileView?.email}</font>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} className="border-bottom01">
                                    <Row className="my-3">
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorBlack01">Mobile</font>
                                            </div>
                                        </Col>
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorGray01">{dataProfileView?.mobile}</font>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12}>
                                    <Row className="my-3">
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorBlack01">Role</font>
                                            </div>
                                        </Col>
                                        <Col xs={3}>
                                            <div>
                                                <font className="fontReg font-size02 colorGray01">{dataProfileView?.role}</font>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default Profile;  